/**
 * Change le thème de la navbar selon la section qu'elle survole.
 * Les sections déclarent data-nav-theme="light" (fond clair) ou "dark" (fond sombre).
 * Ajoute la classe --on-light au menu quand la section sous la navbar est claire.
 */
const PROBE_OFFSET = 60;

export default class NavTheme {
	constructor(smoothScroll) {
		this.smoothScroll = smoothScroll;
		this.nav = document.querySelector(".c-site-menu");
		this.sections = [...document.querySelectorAll("[data-nav-theme]")];
		this.current = null;
		if (!this.nav || !this.sections.length) return;

		this.onScroll = this.onScroll.bind(this);
		this.onTransitionRevealed = () => {
			requestAnimationFrame(() => this.onScroll());
		};

		if (smoothScroll?.scroll) {
			smoothScroll.scroll.on("scroll", this.onScroll);
		} else {
			window.addEventListener("scroll", this.onScroll, { passive: true });
		}

		document.addEventListener("meral:transition-revealed", this.onTransitionRevealed);
		document.addEventListener("meral:loader-complete", this.onTransitionRevealed);

		this.onScroll();
	}

	onScroll() {
		let theme = "dark";
		for (const section of this.sections) {
			const rect = section.getBoundingClientRect();
			if (rect.top <= PROBE_OFFSET && rect.bottom > PROBE_OFFSET) {
				theme = section.dataset.navTheme;
				break;
			}
		}
		if (theme !== this.current) {
			this.current = theme;
			this.nav.classList.toggle("--on-light", theme === "light");
		}
	}

	destroy() {
		document.removeEventListener("meral:transition-revealed", this.onTransitionRevealed);
		document.removeEventListener("meral:loader-complete", this.onTransitionRevealed);
		if (this.smoothScroll?.scroll) {
			this.smoothScroll.scroll.off("scroll", this.onScroll);
		} else {
			window.removeEventListener("scroll", this.onScroll);
		}
	}
}
